export const renewToken = `query {
    renewToken
  }`
